<template>
    <div style="height: 100%">
        <div class="sa-flexbox" style="padding-bottom: 20px">
            <div class="d-flex flex-column">
                <b-row class="sa-label-info">
                    <b-col lg="3">
                        <p>Record Totali: {{ rows }}</p>
                    </b-col>
                    <b-col lg="9">
                        <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
                    </b-col>
                </b-row>
            </div>
            <div class="sa-flexbox-body">
                <div class="b-table-sticky-header">
                    <b-table sticky-header ref="table" stacked="lg" striped hover :items="items" :fields="fields" :current-page="1" :per-page="perPage" :key="listKey" sort-icon-left head-variant="light" class="sa-b-table">
                        <template #cell(index)="riga">
                            {{ riga.index + 1 }}
                        </template>
                        <template #cell(importo)="item">
                            <span> {{ item.item.importo + "€" }}</span>
                        </template>
                        <template #cell(quotaAsl)="item">
                            <span> {{ item.item.quotaAsl + "€" }}</span>
                        </template>
                        <template #cell(quotaComune)="item">
                            <span> {{ item.item.quotaComune + "€" }}</span>
                        </template>
                        <template #cell(quotaUtente)="item">
                            <span> {{ item.item.quotaUtente + "€" }}</span>
                        </template>
                        <template #cell(percentualeAsl)="item">
                            <span> {{ item.item.percentualeAsl + "%" }}</span>
                        </template>
                        <template v-slot:cell(eventi)="{ item }">
                            <b-container class="bv-example-row">
                                <b-button size="sm" v-b-tooltip.hover title="Aggiorna Tariffe" variant="outline-secondary" @click="onClickAggiornaTariffa(item)">
                                    <font-awesome-icon icon="donate"> </font-awesome-icon>
                                </b-button>
                                <b-button size="sm" v-b-tooltip.hover title="Visualizza Prestazione" variant="outline-secondary" @click="onClickView(item)">
                                    <font-awesome-icon icon="eye"> </font-awesome-icon>
                                </b-button>
                                <!-- class="mr-1 no-text" -->
                                <b-button size="sm" v-b-tooltip.hover title="Modifica Prestazione" variant="outline-success" @click="onClickEdit(item)">
                                    <font-awesome-icon icon="edit"> </font-awesome-icon>
                                </b-button>

                                <b-button size="sm" v-b-tooltip.hover title="Cancella Prestazione" variant="outline-danger" @click="onClickDelete(item)">
                                    <font-awesome-icon icon="trash"></font-awesome-icon>
                                </b-button>
                                <b-button size="sm" v-b-tooltip.hover title="Concludi" variant="outline-purple sa-margin-left float-sm-left" @click="onclickAggiornaStato(item)"><i class="fas fa-exchange-alt"></i> </b-button>
                            </b-container>
                        </template>
                    </b-table>
                </div>
                <rsa-configurazione-tipo-prestazione-modal-edit-component ref="cmpRsaConfigurazioneEditComponent" @onSave="onSavePrestazione" @onClose="loadData" @deletePrestazione="loadData"></rsa-configurazione-tipo-prestazione-modal-edit-component>
                <state-change-modal-component ref="cmpStateChangeModalComponent" @cambioStatoSuccess="onCambioStatoSuccess"></state-change-modal-component>
            </div>
            <div class="sa-list-component-footer">
                <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                    <b-col lg="3">
                        <p>Record Totali:{{ rows }}</p>
                    </b-col>
                    <b-col lg="9">
                        <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
                    </b-col>
                </b-row>
            </div>
        </div>
    </div>
</template>
<script>
import UtilityMixin from "../../../utility/UtilityMixin";
import RsaConfigurazioneTipoPrestazioneModalEditComponent from "./RsaConfigurazioneTipoPrestazioneModalEditComponent.vue";
import StateChangeModalComponent from "../../../utility/components/StateChangeModalComponent.vue";

export default {
    components: {
        RsaConfigurazioneTipoPrestazioneModalEditComponent,
        StateChangeModalComponent,
    },
    mixins: [UtilityMixin],
    data() {
        return {
            rows: 0,
            perPage: 50,
            currentPage: 1,
            pathResource: "/rsatipoprestazioni",
            pathResourceAggiornaStato: "/rsatipoprestazionistatistorico",
            showModalLoading: false,
            listKey: 0,
            items: [],
            filtroPrestazioni: { nome: null, codicePrestazione: null },
            btnNuovaPrestazioneHidden: false,
            fields: [
                {
                    label: "",
                    key: "index",
                    sortable: false,
                },
                {
                    label: "Nome",
                    key: "nome",
                    sortable: false,
                },
                {
                    label: "Cod. Prestazione",
                    key: "codicePrestazione",
                    sortable: false,
                },
                {
                    label: "Regime",
                    key: "regime",
                    sortable: false,
                },
                {
                    label: "Importo",
                    key: "importo",
                    sortable: false,
                },
                {
                    label: "Quota ASL(%)",
                    key: "percentualeAsl",
                    sortable: false,
                },
                {
                    label: "Quota ASL(€)",
                    key: "quotaAsl",
                    sortable: false,
                },
                {
                    label: "Stato",
                    key: "statoAttuale",
                    sortable: false,
                },
                {
                    label: "Note",
                    key: "note",
                },
                {
                    class: "sa-table-column-action-double",
                    key: "eventi",
                    label: "",
                },
            ],
        };
    },
    mounted() {
        let me = this;
        me.id = this.$route.params.id;
        me.loadData();
    },
    watch: {
        currentPage() {
            let me = this;
            me.loadData();
        },
    },
    methods: {
        loadData() {
            let me = this;
            me.$emit("beforeLoadData");
            let sessionStorage = window.sessionStorage;
            if (sessionStorage["filtroPrestazioni"]) {
                me.filtroPrestazioni = JSON.parse(sessionStorage["filtroPrestazioni"]);
                me.$emit("updateFilter", me.filtroPrestazioni);
            }
            me.filtroPrestazioni.page = me.currentPage;
            me.filtroPrestazioni.forPage = me.perPage;
            UtilityMixin.methods.loadDataResources(me.pathResource, me.filtroPrestazioni, me.loadDataSuccess, me.loadDataError);
        },
        loadDataSuccess(response) {
            let me = this;
            me.items = response.data.data.list;
            me.rows = response.data.data.recordsNumber;
            me.$emit("afterLoadData");
        },
        loadDataError(error) {
            let me = this;
            console.error("Errore durante il caricamento dei dati:", error);
            me.items = [];
            me.rows = 0;
            me.$emit("afterLoadData");
        },
        onClickView(items) {
            let me = this;
            me.$router.push("/rsatipoprestazioni/view/" + items.id);
        },
        onClickEdit(item) {
            let me = this;
            me.$refs.cmpRsaConfigurazioneEditComponent.show(item);
        },
        onClickNuovoTipoPrestazione() {
            let me = this;
            me.$refs.cmpRsaConfigurazioneEditComponent.show({
                id: null,
                nome: null,
                importo: 0,
                percentualeAsl: null,
                quotaAsl: 0,
                quotaComune: 0,
                quotaUtente: 0,
                note: null,
                codicePrestazione: null,
                regime: null,
            });
        },
        onClickDelete(item) {
            let me = this;
            me.$refs.cmpRsaConfigurazioneEditComponent.onDeletePrestazione(item);
        },
        onClickAggiornaTariffa(item) {
            let routerLink = "/configurazioni/rsatipoprestazioni/aggiornamentotariffa/" + item.id;
            this.$router.push(routerLink);
        },
        onSavePrestazione() {
            let me = this;
            me.loadData();
        },
        onclickAggiornaStato(item) {
            let me = this;
            me.$refs.cmpStateChangeModalComponent.show({ idRsaTipoPrestazione: item.id, dataOra: new Date().getTime() }, null, me.pathResourceAggiornaStato, [{ stato: "ATTIVA" }, { stato: "CHIUSA" }]);
        },
        onCambioStatoSuccess() {
            let me = this;
            me.loadData();
        },
    },
};
</script>
